import {Controller} from "@hotwired/stimulus"
import {Editor} from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'


export default class extends Controller {
    static targets = [
        "editor",
        "hiddenInput",
        "boldToggle",
        "italicToggle",
        "underlineToggle",
        "bulletListToggle",
        "orderedListToggle",
        "undo",
        "redo"
    ]

    connect() {
        const initialContent = this.hiddenInputTarget.value || ''

        this.editor = new Editor({
            element: this.editorTarget,
            extensions: [StarterKit],
            content: initialContent,
            onTransaction: () => {
                this.updateButtonStates()
                this.syncHiddenInput()
            }
        })

        this.editorTarget.addEventListener('onchange', () => {
            console.log("test")
        })

        this.updateButtonStates()
    }

    disconnect() {
        if (this.editor) {
            this.editor.destroy()
        }
    }

    syncHiddenInput() {
        if (!this.hasHiddenInputTarget) return;
        this.hiddenInputTarget.value = this.editor.getHTML()
    }

    updateButtonStates() {
        if (this.hasBoldToggleTarget) {
            const isActive = this.editor.isActive('bold')
            this.boldToggleTarget.classList.toggle('tiptap-btn--active', isActive)
        }
        if (this.hasItalicToggleTarget) {
            const isActive = this.editor.isActive('italic')
            this.italicToggleTarget.classList.toggle('tiptap-btn--active', isActive)
        }
        if (this.hasUnderlineToggleTarget) {
            const isActive = this.editor.isActive('underline')
            this.underlineToggleTarget.classList.toggle('tiptap-btn--active', isActive)
        }
        if (this.hasBulletListToggleTarget) {
            const isActive = this.editor.isActive('bulletList')
            this.bulletListToggleTarget.classList.toggle('tiptap-btn--active', isActive)
        }
        if (this.hasOrderedListToggleTarget) {
            const isActive = this.editor.isActive('orderedList')
            this.orderedListToggleTarget.classList.toggle('tiptap-btn--active', isActive)
        }
        if (this.hasUndoTarget) {
            this.undoTarget.disabled = !this.editor.can().undo()
        }
        if (this.hasRedoTarget) {
            this.redoTarget.disabled = !this.editor.can().redo()
        }
    }

    toggleBold() {
        this.editor.chain().focus().toggleBold().run()
    }

    toggleItalic() {
        this.editor.chain().focus().toggleItalic().run()
    }

    toggleUnderline() {
        this.editor.chain().focus().toggleUnderline().run()
    }

    toggleBulletList() {
        this.editor.chain().focus().toggleBulletList().run()
    }

    toggleOrderedList() {
        this.editor.chain().focus().toggleOrderedList().run()
    }

    undo() {
        this.editor.chain().focus().undo().run()
    }

    redo() {
        this.editor.chain().focus().redo().run()
    }
}
